// extracted by mini-css-extract-plugin
export default {"body":"ShareProjectModal_body__yTdHT","form":"ShareProjectModal_form__5Zqpd","button":"ShareProjectModal_button__xH3Xc","field":"ShareProjectModal_field__bj7JJ"};